"use client";
import { useState, useEffect } from "react";
import clsx from "clsx";
import CommentItem from "./CommentItem";
import { useComment } from "@/hooks/useComment";

const CommentList = ({
  doc_id,
  length,
  qualityComments = []
}: {
  doc_id: string;
  length: number;
  qualityComments?: any[];
}) => {
  const [currentCommentType, setCurrentCommentType] = useState<"hot" | "new">(
    "hot"
  );
  const {
    clearComments,
    fetchComments,
    fetchMoreComments,
    hotComments,
    newComments,
    showMoreComment,
    commentLoading,
  } = useComment(doc_id, qualityComments);

  useEffect(() => {
    fetchComments()
    return () => {
      clearComments()
    }
  }, [doc_id]);
  function handleFetchMoreComment() {
    const last_comment_id = currentCommentList[currentCommentList.length - 1]?.comment_id;
    fetchMoreComments(last_comment_id)
  }

  const currentCommentList = currentCommentType === "hot" ? hotComments : newComments;
  if (commentLoading && qualityComments.length === 0) {
    return <CommentListSkeleton count={Math.min(5, length || 0)} />
  }
  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        {(currentCommentList.length > 0) && (
          <>
            <div
              className={clsx(
                "cursor-pointer px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ease-in-out",
                currentCommentType === "hot"
                  ? "bg-blue-500 text-white shadow-md"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-800"
              )}
              onClick={() => {
                setCurrentCommentType("hot");
              }}
            >
              Hottest
            </div>
            <div
              className={clsx(
                "cursor-pointer px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ease-in-out",
                currentCommentType === "new"
                  ? "bg-blue-500 text-white shadow-md"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-800"
              )}
              onClick={() => {
                setCurrentCommentType("new");
              }}
            >
              Recent
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col gap-4">
        {commentLoading && qualityComments.map((item: any, index: number) => {
          return (
            <CommentItem
              key={item.comment_id || item.reply_id || index}
              data={item}
              doc_id={doc_id}
            />
          );
        })}
        {currentCommentList.map((item: any, index: number) => {
          return (
            <CommentItem
              key={item.comment_id || item.reply_id || index}
              data={item}
              doc_id={doc_id}
            />
          );
        })}
      </div>

      {showMoreComment ? (
        <div
          className="text-blue-500 text-xs w-full flex justify-center items-center gap-1 cursor-pointer mt-5"
          onClick={handleFetchMoreComment}
        >
          <span>More comments {commentLoading && "..."}</span>
        </div>
      ) : (
        <div className={clsx(
          "text-gray-400 text-xs w-full flex justify-center items-center gap-1 cursor-pointer mt-8",
          currentCommentList.length === 0 ? "hidden" : ""
        )}>
          <span>--THE END--</span>
        </div>
      )}

    </div>
  );
};

export default CommentList;

//实现一个comment骨架屏

import React from "react";

const CommentSkeleton = () => {
  return (
    <div className="flex gap-3 animate-pulse py-3 border-b border-gray-100">
      <div className="w-10 h-10 rounded-full bg-gray-200" />
      <div className="flex-1 flex flex-col gap-2">
        <div className="w-24 h-4 bg-gray-200 rounded" />
        <div className="w-full h-3 bg-gray-200 rounded" />
        <div className="w-2/3 h-3 bg-gray-200 rounded" />
        <div className="flex gap-2 mt-2">
          <div className="w-10 h-3 bg-gray-200 rounded" />
          <div className="w-10 h-3 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export const CommentListSkeleton = ({ count = 5 }: { count?: number }) => {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: count }).map((_, idx) => (
        <CommentSkeleton key={idx} />
      ))}
    </div>
  );
};
